<template>
    <div class="row">
        <div class="col-12">
            <label class="form-label">Görev Yeri</label>
            <input type="text" v-model="value.Name" class="form-control" placeholder="Görev Yeri"/>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        value:Object
    }
}
</script>

<style>

</style>